import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const AUTO_LOGOUT_TIME = 15 * 60 * 1000; // 15 minutes

const SessionTimeout = ({ logout }) => {
  const navigate = useNavigate();
  const logoutTimer = useRef(null);

  const resetTimer = () => {
    if (logoutTimer.current) clearTimeout(logoutTimer.current);
    logoutTimer.current = setTimeout(() => {
      logout();
      navigate("/");
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
   const handleBeforeUnload = (e) => {
  const bypass = localStorage.getItem('bypassBeforeUnload');
  if (bypass === 'true') {
    localStorage.removeItem('bypassBeforeUnload'); // clean up
    return;
  }

    e.preventDefault();
      e.returnValue = ''; // Triggers the browser confirmation dialog

      // Save a timestamp to check later if the tab was really closed
      localStorage.setItem('tabCloseAttempt', Date.now().toString());
    };

    const handleUnload = () => {
      const now = Date.now();
      const lastAttempt = parseInt(localStorage.getItem('tabCloseAttempt') || "0", 10);

      // If the tab really closes within 2 seconds of confirmation, user clicked "Yes"
      if (now - lastAttempt < 2000) {
        // Perform logout for all tabs
        localStorage.setItem("logoutEvent", Date.now().toString());
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  

  useEffect(() => {
  const lastLogout = parseInt(localStorage.getItem("logoutEvent") || "0", 10);
  const now = Date.now();

  if (now - lastLogout < 5000) {
    logout();
    navigate("/");
    return;
  }
}, []);

  useEffect(() => {
    const handleUserActivity = () => resetTimer();
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => window.addEventListener(event, handleUserActivity));
    resetTimer();

    return () => {
      if (logoutTimer.current) clearTimeout(logoutTimer.current);
      events.forEach((event) => window.removeEventListener(event, handleUserActivity));
    };
  }, [logout, navigate]);

  return null;
};

export default SessionTimeout;
